/**
 * Datas relativas ("hoje", "amanhã", "daqui a N dias") como expressão JSONata,
 * para quem monta uma automação escolher em vez de escrever a conta.
 *
 * A expressão sai no formato `AAAA-MM-DD`, no fuso de Brasília (`-0300`): é o
 * dia de quem trabalha, e não o do UTC, que vira à meia-noite em Londres. A
 * conta roda no serviço, na hora em que a automação roda — não na hora em que
 * a pessoa salvou.
 */

const DIA_MS = 86_400_000;

/** Os dias que as telas oferecem para escolher, na ordem da lista. */
export const DIAS_RELATIVOS: readonly number[] = [0, 1, 2, 3, 7, 15, 30, -1, -7];
const FUSO = '-0300';
const FORMATO = '[Y0001]-[M01]-[D01]';

/** A expressão do dia de hoje mais `dias` (negativo: dias atrás). */
export function expressaoDaData(dias: number): string {
  const deslocamento = dias === 0 ? '' : ` ${dias > 0 ? '+' : '-'} ${Math.abs(dias) * DIA_MS}`;
  return `$fromMillis($toMillis($now())${deslocamento}, '${FORMATO}', '${FUSO}')`;
}

/** Os dias de uma expressão feita por `expressaoDaData`, ou `null` se for outra. */
export function diasDaExpressao(expressao: string): number | null {
  const m =
    /^\$fromMillis\(\$toMillis\(\$now\(\)\)(?: ([+-]) (\d+))?, '\[Y0001\]-\[M01\]-\[D01\]', '-0300'\)$/.exec(
      expressao.trim(),
    );
  if (!m) return null;
  if (!m[1]) return 0;
  const ms = Number(m[2]);
  if (ms % DIA_MS !== 0) return null;
  return (m[1] === '-' ? -1 : 1) * (ms / DIA_MS);
}

/** O nome do dia relativo, como a tela o mostra. */
export function nomeDosDias(dias: number): string {
  if (dias === 0) return 'Hoje';
  if (dias === 1) return 'Amanhã';
  if (dias === -1) return 'Ontem';
  return dias > 0 ? `Daqui a ${dias} dias` : `Há ${-dias} dias`;
}
